import  React from "react";

import './DetailsTools.scss';

import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { usePdfCreate } from "../../../hooks/usePdfCreate";

import { fetchDetails } from "../../../slices/detailsSlice";
import { openDrawer } from "../../../slices/drawerSlice";

import Print from "@mui/icons-material/Print";
import Notes from "@mui/icons-material/Notes";

import DetailsJournal from "../DetailsJournal/DetailsJournal";

import { Status } from "../../../common-components/Status/Status";
import { TextButton } from "../../../common-components/Buttons/Buttons";

const DetailsTools = ({title, id}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);

    const { generatePdf, reportCode, isClosed } = usePdfCreate();

    useEffect(() => {
        dispatch(fetchDetails({ departureId: id, token }));
    }, [dispatch, id, token]);

    const renderStatus = () => {
        switch (isClosed) {
            case false:
                return <Status title="В процессе" color="danger" />;
            case true:
                return <Status title="Ликвидировано" color="success" />;
            default:
                return null;
        }
    };

    const handlePrint = () => {
        generatePdf();
    }

    const handleOpen = () => {
        dispatch(openDrawer({content: <DetailsJournal departureId={id} token={token}/>}))
    }

    return (
        <div className={"details-tools"}>
            <div className={"details-tools_container"}>
                <div className={"details-tools_number"}>
                    {`${title} ${reportCode}`}
                    {renderStatus()}
                </div>
                <div className={"details-tools_buttons"}>
                    <TextButton Icon={Notes} title={"Журнал"} active={true} onClick={handleOpen}/>
                    <TextButton Icon={Print} title={"Печать"} active={true} onClick={handlePrint}/>
                </div>
            </div>
        </div>
    )
}

export default DetailsTools;